function Admin_Gateway_Management() {
    let adminGatewayManagement = [
        {
            name: "Gateway Mangement",
            icon: "gateway-management",
            logoName: "MyAccounts",
            // flag: "voucherRequired",
            displayService: "AdminGatewayManagement",
            items: []
        }
    ];

    const dashboard = () => {
        const dashboardArr = [
            {
                path: "/index/AdminGateway-Managements",
                name: "Dashboard",
                icon: "dashboard",
                logoName: "dashboard",
                flag: "DASHBOARD"
            },
        ];
        return dashboardArr;
    }

    const gateway_Management_Sub = () => {
        const profileArr = [
            {
                path: "/index/GatewayManagementAdmin",
                name: "Gateway Management",
                icon: "gatewayManagement",
                logoName: "MyBank",
                flag: "GATEWAY MANAGEMENT",
            }
        ];

        // if (
        //   constants.visibleFlags.includes(walletSettings.data[profileArr[0].flag])
        // ) {
        return profileArr;
        // } else {
        //   return "";
        // }
    };

    const Admin_Member_Mapping = () => {
        const memMapping = [
            {
                path: "/index/AdminMemberMapping",
                name: "Member Mapping",
                icon: "memberMapping",
                logoName: "management",
                flag: "MEMBER MAPPING",
            }
        ];

        return memMapping;
    }

    let a = dashboard();
    let b = gateway_Management_Sub();
    let c = Admin_Member_Mapping();

    adminGatewayManagement[0].items = [...a, ...b, ...c];
    return adminGatewayManagement;

}
export default Admin_Gateway_Management